"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// title: 标题
// content：内容
// href: 链接
// type：模块标签类型 hot new
var TciOperate = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var configuration = props.configuration,
      className = props.className,
      style = props.style,
      restProps = __rest(props, ["configuration", "className", "style"]);

  var compatibleArr = configuration;
  var numLenThree = [3, 5, 6].includes(configuration.length);
  var numLenTwo = [2].includes(configuration.length);
  var numLenFour = [4].includes(configuration.length) || configuration.length > 6;
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'flex-operate-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "operate"
  }, compatibleArr === null || compatibleArr === void 0 ? void 0 : compatibleArr.map(function (item, index) {
    var content = item.content,
        title = item.title,
        href = item.href,
        type = item.type,
        extendProps = item.extendProps;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('operate-list', {
        'operate-list--three': numLenThree,
        'operate-list--four': numLenFour,
        'operate-list--two': numLenTwo
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: href
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('operate-list-title', {
        'operate-list-hot': type === 'hot',
        'operate-list-new': type === 'new'
      })
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "operate-list-text",
      dangerouslySetInnerHTML: {
        __html: content
      }
    })));
  })));
});
TciOperate.displayName = 'TciOperate';
var _default = TciOperate;
exports["default"] = _default;